import * as React from "react";
import { connect } from "react-redux";
import { AppState } from "../../../redux";
import { ProfileModuleState } from "../redux/profile";
import { ModalFooter, Submit, Cancel } from "../../../react-components/modals/modal-form-elements";
import { EDIT_PROFILE_SOCIAL_LINKS } from "../redux/profile/constants";
import { submitProfile } from "../redux/profile/actions";
import { SubmitProfileAction } from "../redux/profile/types";
import { SocialLinks } from "../profile/social-links";

interface MapDispatchProps {
  submitProfile: () => SubmitProfileAction;
}

interface MapStateProps {
  screen: string;
  inProgress: boolean;
}

export type Props = MapDispatchProps & MapStateProps;

export const Component = (props: Props) => {
  const { screen, submitProfile, inProgress } = props;
  const shouldDisplay = screen === EDIT_PROFILE_SOCIAL_LINKS;

  const onSubmit = React.useCallback(() => {
    submitProfile();
  }, [submitProfile]);

  const isValid = true;

  if (!shouldDisplay) return null;

  return (
    <Container>
      <div className="form-body">
        <SocialLinks />
      </div>
      <ModalFooter>
        <Cancel />
        <Submit
          onClick={onSubmit}
          disabled={false}
          className={isValid ? `` : "disabled"}
          isSubmitting={inProgress}
          title="Save"
        />
      </ModalFooter>
    </Container>
  );
};

export const Container = ({ children }: React.PropsWithChildren<any>) => {
  return <div className="edit-profile-links edit-profile-form">{children}</div>;
};

const mapState = (state: AppState & ProfileModuleState) => ({
  screen: state.profile.screen,
  inProgress: state.cache.inProgress["submit-profile"],
});

const mapDispatch = {
  submitProfile: submitProfile,
};

export const Links = connect(mapState, mapDispatch)(Component);
